import Box from "@mui/material/Box";
import Chip from "@mui/material/Chip";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { useT } from "../../shared/i18n";

/**
 * Quick-fill chips for the form's owner field: the most-recently-used owners
 * (normally 0–6, empty when there are none yet).
 */
export function OwnerSuggestions({
  suggestions,
  onSelect,
}: {
  suggestions: string[];
  onSelect: (owner: string) => void;
}) {
  const t = useT();
  if (suggestions.length === 0) return null;
  return (
    <Box>
      <Typography variant="caption" color="text.secondary">
        {t("ownerSuggestions")}
      </Typography>
      <Stack direction="row" spacing={0.5} sx={{ mt: 0.5, flexWrap: "wrap", gap: 0.5 }}>
        {suggestions.map((suggestion) => (
          <Chip
            key={suggestion}
            label={suggestion}
            size="small"
            variant="outlined"
            onClick={() => onSelect(suggestion)}
          />
        ))}
      </Stack>
    </Box>
  );
}